import Model from '@/shared/models/CommissionActivation'

export default class CommissionActivation extends Model {}
